import React from 'react';
import { Icon } from './Icon.js';
export const IconPencil2 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M4 12L8.5 16L12 13L15.5 16L20 12", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M8.5 6.5L8.72307 6.81867C10.3155 9.09354 13.6845 9.09354 15.2769 6.81867L15.5 6.5", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M4 21V12L12 2L20 12V21", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconPencil2.js.map